<template>
  <div class="filters">
    <div class="filters--wrapper">
      <search>
        <form class="type">
          <FilterTypeToggleButton />
        </form>
        <form class="value">
          <FilterValueMenu />
        </form>
      </search>
      <div
        v-if="!$isMobile"
        ref="toBottom"
        class="filters--toBottom"
      >
        <BackToTopArrow
          ref="toBottomArrow"
          class="filters--toBottom--arrow"
          @click="$emit('toProducts')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FilterTypeToggleButton from '@/components/common/filter/FilterTypeToggleButton.vue';
import FilterValueMenu from '@/components/common/filter/FilterValueMenu.vue';
import BackToTopArrow from '@/assets/images/decors/icons/back-to-top.svg?inline';
import FilterMixin from '@/components/common/filter/FilterMixin.vue';

export default {
  name: 'ProductFilter',
  components: {
    FilterTypeToggleButton,
    FilterValueMenu,
    BackToTopArrow,
  },
  mixins: [FilterMixin],
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>
<style lang="stylus" scoped>
.filters {
  border-top: 2px $cl-yellow solid;
  background-color: $cl-dark-blue;
  width: 100%;


  +mobile() {
    margin-top: 2px;;
  }

  &--wrapper {
    width: 100%;
    max-width: $container-width;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    search {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      gap: 20px;
      width: fit-content;
      color: $cl-dark-blue;
      padding: 0 20px;
      background-color: $cl-yellow;
      margin-top: -2px;

      +mobile() {
        flex-direction: column;
        gap: 10px;
        padding: 10px 0 0;
        min-width: 100%;
      }

      form {
        display: flex;
        gap: 20px;
        background-color: $cl-yellow;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        +mobile() {
          min-width: 100%;
        }
      }
    }
  }

  .filters--toBottom {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
    color: $cl-yellow;
    // min-height: 40px;

    &--label {
      opacity: 0;
      transition: opacity 0.2s, transform 0.2s;
      transition-delay: 0.2s;
      transform: translateX(10px);
    }

    &--arrow {
      cursor: pointer;
      transform: rotate(180deg);
      width: 30px;
      height: 30px;
      margin: 0 20px;
      transition: --fillColor 0.3s;
      animation: bounce 2.5s infinite;

      path {
        fill: $cl-yellow;
      }

      @keyframes bounce {
        0%, 20%, 50%, 80%, 100% {
          transform: rotate(180deg) translateY(0);
        }
        40% {
          transform: rotate(180deg) translateY(-6px);

        }
        60% {
          transform: rotate(180deg) translateY(-3px);
        }
      }
    }
  }
}
</style>
